<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70" ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Currency Masters Details</b-navbar-brand>
        </b-navbar>

        <b-card>
          <div class="row align-items-end">
            <div class="col-md-3">
              <b-button size="sm" class="pull-left" @click="AddCurrencyModal('add', '')" variant="primary">Add
                Currency</b-button>
            </div>
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3">
              <label for="blType">Date</label>
              <date-range-picker :opens="openRight" :always-show-calendars="showCal" v-model="dateRange"
                :startDate="startDate" :endDate="endDate" :locale-data="locale">
              </date-range-picker>
            </div>
            <div class="col-md-3">
              <label for="CountryName">Country</label>
              <b-form-input :formatter="capitalizeAll" v-model="CountryFilter" type="text"
                placeholder="Enter Country Name"></b-form-input>
            </div>
            <div class="col-md-3">
              <label for="CurrencyName">Currency Name</label>
              <b-form-input :formatter="capitalizeAll" v-model="CurrencyFilter" type="text"
                placeholder="Enter Currency Name"></b-form-input>
            </div>
            <div class="col-md-3">
              <label for="CurrencyCode">Currency Code</label>
              <b-form-input :formatter="capitalizeAll" v-model="CurrencyCodeFilter" type="text"
                placeholder="Enter Currency Code"></b-form-input>
            </div>
            <div class="col-md-3">
              <label for="CurrencyStatus">Currency Status</label>
              <model-list-select :list="isCurrencyactiveList" id="isCurrencyactive" v-model="isCurrencyactiveFilter"
                option-value="inv" option-text="int" placeholder="Select Status">
              </model-list-select>
            </div>

            <div class="col-md-12 mt-2 text-right">
              <b-button size="sm" @click="filterSearch" variant="outline-primary">Search</b-button>
              <b-button size="sm" class="ml-3" @click="clearFilter" variant="outline-info">clear</b-button>
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReports('Currency_REPORTS_SCREEN')"
                variant="outline-info"
              >Export as Excel</b-button> -->
              <b-button :disabled="ExcelBtnName != 'Export as Excel' ? true : false" class="ml-3"
                @click="getReports('Currency_REPORTS_SCREEN', 'Export as Excel')" size="sm" variant="outline-info">{{
                ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small label="Small Spinner"></b-spinner></b-button>
            </div>
          </div>

          <b-row>
            <b-col cols="12" class="ml-2 text-right"> </b-col>
          </b-row>
        </b-card>

        <div class="box">
          <div>
            <b-pagination class="mt-3" limit="25" style="margin: 0px" align="center" v-model="currentPage"
              :per-page="perPage" :total-rows="totalRows" @change="onPageChange($event)">
            </b-pagination>
          </div>
          <div>
            <b-row class="align-content-end mt-3">
              <b-col cols="8"> </b-col>
              <b-col cols="2">
                <h5 class="text-muted pull-right">
                  <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                </h5>
              </b-col>
            </b-row>
          </div>
          <div class="table-responsive tableMain mt-2">
            <b-table show-empty stacked="md" :items="CurrencyList" :fields="fields" :per-page="perPage"
              :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
              <template slot="SN" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="currency" slot-scope="row1">
                <b v-if="row1.item.country">Country : {{ row1.item.country }}<br /></b>
                <b v-if="row1.item.currency">Currency : {{ row1.item.currency }}<br /></b>
                <b v-if="row1.item.currencyCode">Currency Code : {{ row1.item.currencyCode }}<br /></b>
                <span>Created Dt. :{{ row1.item.created_at | moment }}<br /></span>
                <span> By : {{ row1.item.raisedBy }}</span> <br />
              </template>
              <template slot="isCurrencyactive" slot-scope="row5">
                <b>{{ row5.item.currency_status }}</b><br />
                <b-button
                  v-if="$sessionsStorage.get('designation') == 'Admin' &&  $sessionsStorage.get('nameUser') == 'Bhavneesh'"
                  style="font-size: 0.675rem" size="sm" class="mb-1"
                  @click="RemoveCurrency(row5.item.isCurrencyactive == 1 ? 'remove' : 'recover',row5.item)"
                  :variant="row5.item.isCurrencyactive == 1 ? 'danger' : 'success'">{{
                  row5.item.Currencyactive_status_txt }}<br /></b-button><br />
              </template>
              <template slot="currency_id" slot-scope="row4">
                <b-button
                  v-if="$sessionsStorage.get('designation') == 'Admin' &&  $sessionsStorage.get('nameUser') == 'Bhavneesh'"
                  style="font-size: 0.675rem" size="sm" class="mb-1" @click="AddCurrencyModal('edit', row4.item)"
                  variant="primary">Update<br /></b-button>
              </template>
            </b-table>
          </div>
        </div>

        <div>
          <b-pagination limit="25" align="center" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
            @change="onPageChange($event)"></b-pagination>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="modal-Add-Open" hide-footer
      :title="CurrencyDetails.Type == 'add' ? 'Add Currency' : 'Update Currency'">
      <b-row class="justify-content-center">
        <b-col md="3" class="mt-2">
          <label for="CurrencyName">Currency Name : <span class="error">*</span></label>
          <b-form-input :formatter="capitalizeAll" v-model="CurrencyDetails.currency" type="text"
            placeholder="Enter Currency Name"></b-form-input>
          <span class="error" v-if="!CurrencyDetails.currency">{{errorCurrencyDetails.currency}}</span>
        </b-col>
        <b-col md="3" class="mt-2">
          <label for="CurrencyCode">Currency Code : <span class="error">*</span></label>
          <b-form-input :formatter="capitalizeAll" v-model="CurrencyDetails.currencyCode" type="text"
            placeholder="Enter Currency Code"></b-form-input>
          <span class="error" v-if="!CurrencyDetails.currencyCode">{{errorCurrencyDetails.currencyCode}}</span>
        </b-col>
        <b-col md="3" class="mt-2">
          <label for="CountryName">Country Name. : <span class="error">*</span></label>
          <b-form-input :formatter="capitalizeAll" v-model="CurrencyDetails.country" type="text"
            placeholder="Enter Country Name"></b-form-input>
          <span class="error" v-if="!CurrencyDetails.country">{{errorCurrencyDetails.country}}</span>
        </b-col>


        <b-col md="12" class="text-center">
          <b-button :disabled="isCurrencydisabled" class="mt-3 sm" variant="success"
            v-if="CurrencyDetails.currency != ''" @click="submitCurrency">{{ buttonTxt }}</b-button>
          <b-button class="mt-3 sm" variant="outline-danger" @click="closeModalAdd">Close</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Added By Priyanshu SIngh End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import DateRangePicker from "vue2-daterange-picker";
import CustomLoader from "../common/customLoader.vue";
import {
  globalPermissionStatus,
  lastVisitPage,
  GlobalGetLocation,
} from "../../helper/collection";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    this.$store.dispatch("setCurrentRoute", "/currencyMaster");
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.viewCurrencyList("0", "1", "1");
    }
  },

  data() {
    return {
      ExcelBtnName: "Export as Excel",
      //Added By Priyanshu Singh Console Currency Variable Start
      currency: "",
      currency_id: "",
      buttonTxt: "Save",
      isCurrencydisabled: false,
      CurrencyData: [],
      selectDateFormat,
      CurrencyDetails: {
        Type: "add",
        currency: "",
        currencyCode: "",
        country: "",
        currency_id: "",
      },
      errorCurrencyDetails: {
        country: "",
        currency: "",
        currencyCode: "",
      },
      arrayErrorCurrencyDetails: [
        {
          country: "Please Enter Country",
          currency: "Please Enter Currency",
          currencyCode: "Please Enter Currency Code",
        },
      ],
      CurrencyList: [],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      clientIdFilter: "",
      CurrencyFilter: "",
      CurrencyCodeFilter: "",
      CountryFilter: "",
      isCurrencyactiveFilter: "3",
      clientMaster: [],
      isCurrencyactiveList: [
        {
          inv: "1",
          int: "Active",
        },
        {
          inv: "2",
          int: "In-Active",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      validate: false,
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 25,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "currency",
          mainkey: "currency",
          label: "Currency.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "isCurrencyactive",
          mainkey: "isCurrencyactive",
          label: "Currency Status",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "currency_id",
          mainkey: "currency_id",
          label: "Actions",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      reload: true,
      //Added By Priyanshu Singh  Console Currency Variable Start
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},
  destroyed() {},

  components: {
    // Loading,
    DatePicker,
    ModelListSelect,
    MultiSelect,
    DateRangePicker,
    CustomLoader,
  },

  computed: {},
  watch: {},
  methods: {
    wordWrap,
    previousSalesView() {
      window.history.go(-1);
    },
    validateCurrency() {
      let validate_new = true;
      Object.keys(this.errorCurrencyDetails).map((x, index) => {
        if (this.CurrencyData[x] == "") {
          this.errorCurrencyDetails[x] = this.arrayErrorCurrencyDetails[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    submitCurrency() {
      this.CurrencyData["currency"] = this.CurrencyDetails.currency;
      this.CurrencyData["currencyCode"] = this.CurrencyDetails.currencyCode;
      this.CurrencyData["country"] = this.CurrencyDetails.country;
      this.CurrencyData["Type"] = this.CurrencyDetails.Type;
      this.CurrencyData["currency_id"] = this.CurrencyDetails.currency_id;
      this.validateCurrency();
      if (this.validate == false) return false;
      this.isLoading = true;
      this.isCurrencydisabled = true;
      if (this.validate != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addCurrency.php`,
          data: JSON.stringify(this.CurrencyDetails),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.currency_id != "" && data.currency_id != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.CurrencyDetails.currency_id = "";
                  this.CurrencyDetails.currency = "";
                  this.CurrencyDetails.currencyCode = "";
                  this.CurrencyDetails.country = "";
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.isCurrencydisabled = false;

              Object.keys(this.CurrencyData).map((x) => {
                this.CurrencyData[x] = "";
              });
              this.$refs["modal-Add-Open"].hide();
              this.$refs["addPop"].open();
              this.viewCurrencyList("0", "1", "1");
            }
          })
          .catch((error) => {});
      }
    },
    AddCurrencyModal(type, item) {
      this.CurrencyDetails.Type = type;
      this.CurrencyDetails.currency = "";
      this.CurrencyDetails.currencyCode = "";
      this.CurrencyDetails.country = "";
      if (type == "edit") {
        this.CurrencyDetails.Type = type;
        this.CurrencyDetails.currency = item.currency;
        this.CurrencyDetails.currencyCode = item.currencyCode;
        this.CurrencyDetails.country = item.country;
        this.CurrencyDetails.currency_id = item.currency_id;
        this.buttonTxt = "Update";
      }
      this.$refs["modal-Add-Open"].show();
    },
    closeModalAdd() {
      this.$refs["modal-Add-Open"].hide();
    },
    RemoveCurrency(type, item) {
      if ((type == "remove" || type == "recover") && item.currency_id != "") {
        let payload = {
          Type: type,
          currency_id: item.currency_id,
          currency: item.currency,
          Currencyactive_status_txt: item.Currencyactive_status_txt,
          currencyactive_status: item.currencyactive_status,
        };
        // console.log("payload=>",payload);return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addCurrency.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.currency_id != "" && data.currency_id != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.CurrencyDetails.currency_id = "";
                  this.CurrencyDetails.currency = "";
                  this.CurrencyDetails.currencyCode = "";
                  this.CurrencyDetails.country = "";
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.viewCurrencyList("0", "1", "1");
            }
          })
          .catch((error) => {});
      }
    },
    getReports(id, btnName) {
      this.isLoading = true;
      let excelIdGivin = "";
      if (id == "Currency_REPORTS_SCREEN") {
        excelIdGivin = "Currency_REPORTS_SCREEN";
      }
      let view_Assignment = {
        excelId: excelIdGivin,
        CurrencyFilter: this.CurrencyFilter,
        CurrencyCodeFilter: this.CurrencyCodeFilter,
        CountryFilter: this.CountryFilter,
        isCurrencyactiveFilter: this.isCurrencyactiveFilter,
        searchVal: this.filter,
        Currency: "Currency",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      this.ExcelBtnName = "Downloading Please Wait....";
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewAllCurrencyList.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.ExcelBtnName = btnName;
            if (data.excelName != undefined) {
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` +
                data.excelName;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewCurrencyList(CURRENT, "2", event);
    },
    filterSearch() {
      this.reload = false;
      this.viewCurrencyList("0", "1", "1");
    },
    clearFilter() {
      this.CurrencyFilter = "";
      this.CurrencyCodeFilter = "";
      this.CountryFilter = "";
      this.isCurrencyactiveFilter = "";

      (this.dateRange = {
        startDate: "",
        endDate: "",
      }),
        this.viewCurrencyList("0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }
      this.viewCurrencyList(CURRENT, "2", event);
    },
    viewCurrencyList(CURRENT, SEARCH, pageNumber) {
      this.CurrencyList = [];
      this.isLoading = true;
      let payload = {
        excelId:'Noraml_List_Page',
        cust_username: this.$sessionsStorage.get("cust_username"),
        CurrencyFilter: this.CurrencyFilter,
        CurrencyCodeFilter: this.CurrencyCodeFilter,
        CountryFilter: this.CountryFilter,
        isCurrencyactiveFilter: this.isCurrencyactiveFilter,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        Currency: "Currency",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewAllCurrencyList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (
                this.lastVisitPage &&
                this.$sessionsStorage.get("lastVisitPage")
              ) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            console.log("Priyanshu Singh=>", data);

            if (data.currencyData.length > 0) {
              data.currencyData.forEach((element) => {
                element["currency_id"] = element.currency_id;
                element["currency"] = element.currency;
                element["isCurrencyactive"] = element.isCurrencyactive;
                if (element.isCurrencyactive == 0) {
                  element["Currencyactive_status_txt"] = "Recover";
                  element["currencyactive_status"] = 1;
                  element["currency_status"] = "In-Active";
                } else if (element.isCurrencyactive == 1) {
                  element["Currencyactive_status_txt"] = "Remove";
                  element["currencyactive_status"] = 0;
                  element["currency_status"] = "Active";
                }
                element["closingReasontxt"] = element.closingReasontxt;
                element["closedBy"] = element.closedBy;
                this.CurrencyList.push(element);
              });
            } else {
              this.CurrencyList = [];
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    pagechangeData() {
      this.perPage = 25;
      this.reload = false;
      this.viewCurrencyList("0", "1", "1");
    },
    //Added By Priyanshu SIngh Multi Select End
  },
};
</script>



// WEBPACK FOOTER //
// currencyMasters.vue?81b87cfe